import { render, staticRenderFns } from "./HomeImage.vue?vue&type=template&id=28852812&"
import script from "./HomeImage.vue?vue&type=script&lang=js&"
export * from "./HomeImage.vue?vue&type=script&lang=js&"
import style0 from "./HomeImage.vue?vue&type=style&index=0&id=28852812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports